<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white"> Cotizaciones </h4>
            </div>
            <div class="card-body">
                <form class="form-horizontal" #clienteContratoForm="ngForm">
                    <div class="form-body">
                        <button class="btn btn-secondary float-right" routerLink="cotizador">
                              Crear una Cotizacion
                          </button>
                    </div>
                </form>
            </div>
            <div class="table-responsive">
                <table datatable [dtOptions]="dtOptions" id="tablaCotizaciones" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Fecha</th>
                            <th>Estatus</th>
                            <th>Creado por</th>
                            <th>Sucursal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let cotizacion of cotizacionesArray">
                            <td>{{ cotizacion.id }}</td>
                            <td>{{ cotizacion.descripcion }}</td>
                            <td>{{ cotizacion.fecha }}</td>
                            <td><span class="label" [style.background]="cotizacion.estatus.color">{{ cotizacion.estatus.nombre }}</span></td>
                            <td>{{ cotizacion.usuario }}</td>
                            <td>{{ cotizacion.sucursal }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/listar-cotizaciones/listar-cotizaciones.component.html